const getRailsType = (type) => {
  switch (type) {
    case 'user-post':
    case 'posts_feed_post': // draft post
      return 'Post';

    case 'posts_topic_post':
      return 'Posts::TopicPost';

    case 'opportunity':
    case 'business_opportunities_request':
      return 'BusinessOpportunities::Request';

    case 'network-post':
    case 'communications_post_communication':
      return 'Communication';

    case 'venture':
    case 'ventures_venture':
      return 'Ventures::Venture';

    case 'trip':
    case 'live':
    case 'check-in':
    case 'current':
      return 'Location';

    case 'user-event':
    case 'event':
      return 'Event';

    case 'network-event':
    case 'network_events_event':
      return 'NetworkEvents::Event';

    case 'user':
      return 'User';

    default:
      return null;
  }
};

export default getRailsType;
